import {GetHealthAppointmentsHistory} from 'domain/usecases';
import {RemoteGetAppointmentsHistory} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookedFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthAppointmentsHistory = (): GetHealthAppointmentsHistory =>
	new RemoteGetAppointmentsHistory(
		makeBFFApiUrl(BookedFlowEndPoints.healthAppointmentsHistory),
		makeAuthorizeHttpClientDecorator(),
	);
